import React, { useState, useCallback } from 'react';

export function useConfirm() {
    const [state, setState] = useState(null);

    const confirm = useCallback((options) => {
        return new Promise((resolve) => {
            setState({ ...options, resolve });
        });
    }, []);

    const handleConfirm = () => {
        if (state?.resolve) state.resolve(true);
        setState(null);
    };

    const handleCancel = () => {
        if (state?.resolve) state.resolve(false);
        setState(null);
    };

    const dialog = state ? (
        <div
            style={{
                position: 'fixed', inset: 0, zIndex: 10001,
                background: 'rgba(0,0,0,0.45)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                animation: 'ap-confirm-fade 0.18s ease',
            }}
            onClick={handleCancel}
        >
            <div
                style={{
                    background: 'var(--ap-surface, #fff)',
                    border: '1px solid var(--ap-border, #e2e8f0)',
                    borderRadius: 'var(--ap-r-lg, 10px)',
                    padding: '24px 28px',
                    minWidth: 340, maxWidth: 480,
                    boxShadow: 'var(--ap-shadow-lg, 0 16px 48px rgba(0,0,0,0.18))',
                    animation: 'ap-confirm-pop 0.22s cubic-bezier(0.16,1,0.3,1)',
                }}
                onClick={e => e.stopPropagation()}
            >
                <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ap-text, #1e293b)', marginBottom: 8 }}>
                    {state.title}
                </div>
                <div style={{ fontSize: 13, color: 'var(--ap-text-2, #64748b)', lineHeight: 1.6, marginBottom: 20 }}>
                    {state.message}
                </div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    <button
                        onClick={handleCancel}
                        style={{
                            padding: '7px 18px', fontSize: 13, borderRadius: 6,
                            border: '1px solid var(--ap-border, #e2e8f0)',
                            background: 'transparent', color: 'var(--ap-text-2, #64748b)',
                            cursor: 'pointer', fontFamily: 'inherit',
                        }}
                    >
                        {state.cancelLabel || 'Cancel'}
                    </button>
                    <button
                        onClick={handleConfirm}
                        style={{
                            padding: '7px 18px', fontSize: 13, borderRadius: 6, border: 'none',
                            background: state.danger ? 'var(--ap-danger, #dc2626)' : 'var(--ap-accent, #1b2a4a)',
                            color: '#fff', cursor: 'pointer', fontWeight: 600, fontFamily: 'inherit',
                        }}
                    >
                        {state.confirmLabel || 'Confirm'}
                    </button>
                </div>
            </div>
        </div>
    ) : null;

    return { confirm, dialog };
}
